import { SCol, SRow, SSelect } from "@avalara/skylab-sdk/react";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { linkBucketToLocation } from "../../../../app/bucketsSlice/bucketActions";
import featureFlag from "../../../../featureToggler/featureFlag";
import { useIsAuthorized } from "../../../../hooks/useIsAuthorized";

const AssignLocation = ({ availableLocations, isLocationLoading, bucketId }) => {
    const dispatch = useDispatch();
    const [selectedLocationsToAssign, setSelectedLocationsToAssign] = useState([]);
    const [isAssigning, setIsAssigning] = useState(false);
    const canAddEditDeleteBucketsLocations = useIsAuthorized(
        featureFlag.settings.addEditDeleteBucketsLocations
    );
    const getLocationOptions = useCallback(() => {
        return (availableLocations || []).map(location => ({
            label: location.name,
            value: String(location.id),
            selected: selectedLocationsToAssign.includes(String(location.id)),
        }));
    }, [availableLocations, selectedLocationsToAssign]);

    const handleLocationSelect = useCallback(
        e => {
            const newValue = e?.detail?.item?.value;
            if (newValue) {
                const currentValues = selectedLocationsToAssign || [];
                if (!currentValues.includes(newValue)) {
                    setSelectedLocationsToAssign([...currentValues, newValue]);
                }
            }
        },
        [selectedLocationsToAssign]
    );

    const handleLocationDeselect = useCallback(
        e => {
            if (e?.detail?.isDeselectAll) {
                setSelectedLocationsToAssign([]);
                return;
            }
            const deselectedValue = e?.detail?.item?.value;
            if (deselectedValue) {
                const currentValues = selectedLocationsToAssign.filter(v => v !== deselectedValue);
                setSelectedLocationsToAssign(currentValues);
            }
        },
        [selectedLocationsToAssign]
    );

    const handleAssignLocation = useCallback(() => {
        if (selectedLocationsToAssign.length > 0) {
            setIsAssigning(true);
            const payload = {
                BucketId: bucketId,
                LocationIds: selectedLocationsToAssign,
            };
            dispatch(linkBucketToLocation(payload));
            setSelectedLocationsToAssign([]);
            setIsAssigning(false);
        }
    }, [selectedLocationsToAssign, dispatch, bucketId]);

    return (
        <SRow className="margin-bottom-md">
            <SCol span="12">
                <h3>Assign locations to the bucket</h3>
                <div className="margin-bottom-md">
                    <SRow className="align-items-center">
                        <SCol span="6">
                            <label htmlFor="location" id="lbl-location">
                                Search for a location
                            </label>
                            <SSelect
                                inputId="location"
                                name="location"
                                multiple
                                predictiveSearch
                                optionsList={getLocationOptions()}
                                onS-select={handleLocationSelect}
                                onS-deselect={handleLocationDeselect}
                                disabled={isLocationLoading}>
                                <div slot="sticky-footer">
                                    <button
                                        className="primary margin-all-sm"
                                        onClick={handleAssignLocation}
                                        disabled={
                                            isAssigning ||
                                            selectedLocationsToAssign.length === 0 ||
                                            !canAddEditDeleteBucketsLocations
                                        }>
                                        Assign
                                    </button>
                                </div>
                            </SSelect>
                        </SCol>
                    </SRow>
                </div>
            </SCol>
        </SRow>
    );
};

export default AssignLocation;
